import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CEOPreview() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="py-28 bg-white overflow-hidden">
      <div className="max-w-screen-xl mx-auto px-8">
        <div ref={ref} className="flex flex-col lg:flex-row items-center gap-16">
          {/* Image Side */}
          <div className={`scroll-hidden-left ${isVisible ? 'scroll-visible' : ''} relative flex-shrink-0 w-full lg:w-[420px]`}>
            <div className="relative">
              {/* Decorative background shape */}
              <div className="absolute -top-6 -left-6 w-full h-full rounded-3xl bg-gradient-purple opacity-20" />
              <div className="absolute -bottom-6 -right-6 w-full h-full rounded-3xl bg-brand-yellow/20" />

              <div className="relative w-full h-[520px] rounded-3xl overflow-hidden border-4 border-white pulse-border">
                <img
                  src="https://storage.readdy-site.link/project_files/979cb23d-2376-41a4-bad4-0dbbe3d67aab/2d9e19dd-2fc1-41c3-a511-b4da8cbfe6bf_IMG_1179.jpeg?v=70883f97922a09b701fcbe2553884e50"
                  alt="Jaquan Little - Founder & CEO of Creative Institute"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-purple-dark/60 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="font-heading text-white text-xl font-bold">Jaquan Little</p>
                  <p className="font-body text-brand-yellow text-sm">Founder &amp; Creative Director</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className={`scroll-hidden-right ${isVisible ? 'scroll-visible' : ''} flex-1`}>
            <span className="inline-block px-4 py-1.5 rounded-full bg-brand-purple/10 text-brand-purple font-body text-xs font-semibold uppercase tracking-widest mb-5">
              Meet the Visionary
            </span>

            <h2 className="font-heading text-5xl font-black text-brand-blue-dark mb-6 leading-tight">
              Behind the<br />
              <span className="gradient-text">Movement</span>
            </h2>

            <p className="font-body text-gray-600 text-base leading-relaxed mb-5">
              Jaquan Little is a world-renowned worship and arts director and distinguished Creative Media Strategist, recognized for his ability to lead, develop, and elevate creatives across multiple artistic disciplines.
            </p>

            <p className="font-body text-gray-600 text-base leading-relaxed mb-6">
              With a distinguished career spanning major productions and collaborations with countless gospel artists and creative professionals, Jaquan brings unmatched expertise and vision to every room he enters.
            </p>

            <div className="flex items-center gap-6 mb-8 p-5 rounded-xl bg-brand-purple-soft border-l-4 border-brand-purple">
              <i className="ri-double-quotes-l text-3xl text-brand-purple flex-shrink-0" />
              <p className="font-body text-brand-blue-dark text-sm leading-relaxed italic">
                He is passionate about developing people, not just talent — creating a safe, structured, and empowering space for all creatives, including neurodivergent individuals.
              </p>
            </div>

            <Link
              to="/meet-the-founder"
              className="whitespace-nowrap inline-flex items-center gap-3 px-8 py-4 rounded-full bg-gradient-to-r from-[#1E3A8A] to-[#5B21B6] text-white font-body font-semibold text-base hover:opacity-90 transition-all duration-300 cursor-pointer"
            >
              Read Full Story
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base" />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
